import { type AppDispatch, type RootState } from '../../../../store'
import { dataFetchingFinish, dataFetchingStart } from '../../../../slices/modalSlice'
import { landlordAddUnitWriteToStorage } from '../utils/landlordAddUnitHandleStorage'
import nanToNull from '../../../../../functions/adapters/universal/nanToNull'
import { type NavigateFunction } from 'react-router-dom'

export const addMainInfoFirst = (unitID?: number) => (data: any) => async (dispatch: AppDispatch, getState: () => RootState): Promise<any> => {
    dispatch(dataFetchingStart())
    try {
        data.SizeArea = nanToNull(data.SizeArea)
        landlordAddUnitWriteToStorage('main_unit_info_first', data)
        return {
            textNotification: '',
            textNavigate: `/landlord/modal/landlord_create_main_info_second/${nanToNull(unitID) ?? '-'}/-`,
            isSuccessful: true
        }
    } catch (err) {
        console.log('Error while adding main unit info first modal', err)
    }
    dispatch(dataFetchingFinish())
    return {
        isSuccessful: false
    }
}

export const skipAddMainInfoFirst = (navigate: NavigateFunction, unitID?: number) => async () => {
    navigate(`/landlord/modal/landlord_create_main_info_second/${nanToNull(unitID) ?? '-'}/-`)
}

export const goBackAddMainInfoFirst = (navigate: NavigateFunction, unitID?: number) => () => {
    navigate(`/landlord/modal/landlord_create_unit_info/${nanToNull(unitID) ?? '-'}/-`)
}
